import React from 'react';
import {Grid,Divider} from '@material-ui/core'
import CheckBoxInput from '../Inputs/CheckBoxInput'
import CheckBoxDatum from '../Inputs/CheckBoxDatum'
import CheckBoxInputAvtal from '../Inputs/CheckBoxInputAvtal'
import CheckBoxInputAvtalTyp from '../Inputs/CheckBoxInputAvtalTyp'
import CheckBoxInputAgare from '../Inputs/CheckBoxInputAgare'
import CheckBoxInputAvtalStatus from '../Inputs/CheckBoxInputAvtalStatus'
import CheckBoxInputAvtalleverant from '../Inputs/CheckBoxInputAvtalleverant'
import CheckBoxInputProspektStatus from '../Inputs/CheckBoxInputProspektStatus'
import CheckBoxInputProspektFas from '../Inputs/CheckBoxInputProspektFas'
import CheckBoxInputBetalning from '../Inputs/CheckBoxInputBetalning'
import {useSelector} from 'react-redux'
function AvtalSection(props) {
    const hasfortnox = useSelector(state=>state.accountsData.Flags.Fortnox)
    let IsAll = props.Mstate.filter(n=>{return n.Meta === 'Avtal/Prospekt'})[0].Value
    const isAvtal = parseInt(IsAll) ===1 ||parseInt(IsAll) ===4?1:0
    const isProspekt = parseInt(IsAll) ===2 ||parseInt(IsAll) ===3?1:0
    return (
        <>
             <Grid
            container
            direction="row"
            alignItems="center"
            >
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAvtal Meta="Avtal/Prospekt" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Id" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAvtalTyp Meta="Typ" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAvtalleverant Meta="Leverantör" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInputAgare Meta="Ägare" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Rubrik" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                {
                    parseInt(hasfortnox) === 1?
                    <Grid item xs={3} className={"p-1"}>
                        <CheckBoxInputBetalning Meta="Avtal fakturastatus" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid> 
                    :""
                }
                {
                     parseInt(hasfortnox) === 1?
                     <Grid item xs={3} className={"p-1"}>
                         <CheckBoxInput Meta="Faktura datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                     </Grid> 
                     :""
                }
                {
                    parseInt(hasfortnox) === 1?
                    <Grid item xs={3} className={"p-1"}>
                        <CheckBoxInput Meta="Betalatdatum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid> 
                    :""
                }
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Avtal TB" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Avtal Inpris" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={3} className={"p-1"}>
                    <CheckBoxInput Meta="Avtal Utpris" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                {  
                    isAvtal === 1?
                    <Grid item xs={3} className={"p-1"}>
                        <CheckBoxInputAvtalStatus Meta="Avtal status" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid> 
                    :""
                }
                {
                    isProspekt  === 1?
                    <Grid item xs={3} className={"p-1"}>
                        <CheckBoxInputProspektStatus Meta="Prospekt status" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid> 
                    :""
                }
                {
                    isProspekt  === 1?
                    <Grid item xs={3} className={"p-1"}>
                        <CheckBoxInputProspektFas Meta="Prospekt fas" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid> 
                    :""
                }
               
                
                
                <Grid item xs={12} className={"p-1"}>
                <Divider/>
                </Grid>
                <Grid item xs={6} className={"p-1"}>
                    <CheckBoxDatum Meta="Avtal skapa datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                <Grid item xs={6} className={"p-1"}>
                    <CheckBoxDatum Meta="Avtal start datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid> 
                {  
                    isAvtal === 1?
                    <>
                <Grid item xs={6} className={"p-1"}>
                    <CheckBoxDatum Meta="Avtal omförhandling datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                <Grid item xs={6} className={"p-1"}>
                    <CheckBoxDatum Meta="Avtal löper ut datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                </Grid>
                </>:""
                }
                {
                    isProspekt  === 1?
                    <Grid item xs={6} className={"p-1"}>
                        <CheckBoxDatum Meta="Prospekt deadline datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid>
                    :""
                }
                {
                    parseInt(hasfortnox) === 1?
                    <Grid item xs={6} className={"p-1"}>
                        <CheckBoxDatum Meta="Faktura datum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid>
                    :""
                }
                {
                    parseInt(hasfortnox) === 1?
                    <Grid item xs={6} className={"p-1"}>
                        <CheckBoxDatum Meta="Betalatdatum" disabled={false}  Value={true} onChangeMstate={props.onChangeMstate} Mstate={props.Mstate}/>
                    </Grid>
                    :""
                }
            </Grid>
        </>
    );
}

export default AvtalSection;